import { TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import FilteredTableDataCell from './FilteredTableDataCell';

export default function FilteredTableDataRow({ type, issue, dropdownTable, columns, isStripedRow }) {
  return (
    <>
      <TableRow
        sx={isStripedRow ? { backgroundColor: (theme) => theme.palette.primary.light } : undefined}
        key={issue.id}
      >
        {columns.map((key) => (
          <FilteredTableDataCell
            type={type}
            key={key}
            data={issue.cells}
            index={key}
            dropdownTable={dropdownTable}
            cellSx={{
              padding: '6px',
              textAlign: 'left',
              border: (theme) => `1px solid ${theme.palette.secondary.dark}`,
            }}
          />
        ))}
      </TableRow>
    </>
  );
}

FilteredTableDataRow.propTypes = {
  columns: PropTypes.array,
  dropdownTable: PropTypes.object,
  isStripedRow: PropTypes.bool,
  issue: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    cells: PropTypes.object,
  }),
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
